import React, { useEffect, useRef, useState } from 'react';
import CustomTable from '../../../../customComponents/CustomTable';
import { TABLE_DATA, TABLE_HEADERS, keyMapping } from '../../../../../constants/OnboardList';
import downloadIcon from './../../../../../Assets/icons/download.svg';
import searchIcon from './../../../../../Assets/icons/searchicon.svg';
import './index.scss';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../../../services/api/API';
import ROUTES_NAVIGATION from '../../../../../routes/routes';
import ListLogisticsFilters from '../../../Logistics/LogisticsFilter';
import { IoMdClose } from 'react-icons/io';
import SearchInput from '../../../../customComponents/CustomSearch/SearchInput';
import Loader from '../../../../customComponents/CustomLoader';


const Onboard = () => {
  const [activeSection, setActiveSection] = useState('Customer');
  const [searchTerm, setSearchTerm] = useState('');
  const [totalRecords, setTotalRecords] = useState(0);
  const [ totalcust, setTotalCust ] = useState(0)
  const [ totalagent, setTotalAgent ] = useState(0)
  const [ city, setCity ] = useState([])
  const [ filters, setFilters ] = useState({})
  const [ onBoardList, setOnBoardList ] = useState([])
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [ filterFormData, setFilterFormData ] = useState({})
  const [validationErrors, setValidationErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const token = localStorage.getItem("authToken");
  const userType = localStorage.getItem("UserType");
  const BUSINESSPARTNERID = localStorage.getItem("UserType");
  const pdfRef = useRef();

  const navigate = useNavigate();

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchOnBoardList( 10, newPage);
  };

  const renderTableData = () => {
    let filteredData = [];
    switch (activeSection) {
      case 'Customer':
        filteredData = onBoardList
        
        break;
      case 'Agent':
        filteredData = onBoardList
        
        break;
      case 'Company':
        filteredData = TABLE_DATA.companies.filter(company =>
          Object.values(company).some(value =>
            String(value).toLowerCase().includes(searchTerm.toLowerCase())
          )
        );
        break;
      default:
        filteredData = [];
    }
    return filteredData;
  };

  const renderTableHeaders = () => {
    switch (activeSection) {
      case 'Customer':
        return TABLE_HEADERS.customers;
      case 'Agent':
        return TABLE_HEADERS.agents;
      case 'Company':
        return TABLE_HEADERS.companies;
      default:
        return [];
    }
  };

  const renderKeyMapping = () => {
    switch (activeSection) {
      case 'Customer':
        return keyMapping.customers;
      case 'Agent':
        return keyMapping.agents;
      case 'Company':
        return keyMapping.companies;
      default:
        return [];
    }
  };

  const renderAddButtonLabel = () => {
    switch (activeSection) {
      case 'Customer':
        return 'Add Partner ';
      case 'Agent':
        return 'Add Partner';
      case 'Company':
        return 'Add Partner';
      default:
        return 'Add New';
    }
  };

  useEffect(() => {
    fetchCity()
  },[])

  const fetchCity = async () => {
    try {
      const response = await axiosInstance.post("/bp-onboard/ddlbpcity",{
        business_partner_id:userType==="superadmin"?null:BUSINESSPARTNERID ,
      
      }, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const data = response.data.data.data; 
      const cityOptions = data.map(city => ({
        value: city.ID,
        label: city.NAME,
      }));
      setCity(cityOptions);
    } catch (error) {
      console.log(error); 
    }
  };
  const handleAddButtonClick = () => {
    switch (activeSection) {
      case 'Customer':
        navigate('/admin/manage-onboard/onboard/create-customer', { state: { data: onBoardList } });
        localStorage.setItem("onBoardList",  onBoardList)
        break;
      case 'Agent':
        navigate('/admin/manage-onboard/onboard/create-agent', { state: { data: onBoardList } });
        localStorage.setItem("onBoardList",  onBoardList)
        break;
      case 'Company':
        navigate('/admin/manage-onboard/onboard/create-company');
        break;
      default:
        break;
    }
  };
  

 
  // filteredData

  const fetchOnBoardList = async (pageSize = 10,  page = 0 ) => {
    console.log(filters, "FILTERS")
    const allfilteredData = filters

    try {
      setLoading(true)
      const response = await axiosInstance.post(
        '/bp-onboard/list',
        {
        orderBy: 'onboard_id desc',
          page,
          pageSize,
          startDate: allfilteredData?.fromDate?allfilteredData?.fromDate:null ,
          endDate: allfilteredData?.toDate?allfilteredData?.toDate:null ,
          city_id: allfilteredData?.city? allfilteredData?.city :null,
          searchText:searchTerm
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const formattedData = response?.data?.data?.data?.map((item, index) => {
        // Store bp_type in local storage
        localStorage.setItem(`bp_type_${index}`, item.bp_type);
        
        return {
          ...item,
          'Sr No.': index + 1,
          // "state_name":  item.state_name.charAt(0).toUpperCase() + item.state_name.slice(1).toLowerCase(),
          // "city_name": item.city_name.charAt(0).toUpperCase() + item.city_name.slice(1).toLowerCase(),
        };
      });

      const totalRecordsData = response?.data?.data?.totalRecords

      const totalCustomer = response?.data?.data?.total_customer
      const totalAgent = response?.data?.data?.total_agent

      console.log(totalCustomer, "TOTALCUSTOMER")
      console.log(totalAgent, "TOTALAGENT")

      console.log(totalRecordsData, "RECORDS")
      setTotalRecords(totalRecordsData);
      setTotalCust(totalCustomer)
      setTotalAgent(totalAgent)

      setOnBoardList(formattedData);
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
    } catch (error) {
      console.error('Error fetching list:', error);
    }
    finally{
      setLoading(false)
    }
  }

  const handleEdit = (rowData) => {
    console.log("rowdata>", rowData);
    navigate(`${ROUTES_NAVIGATION.EDITCUSTOMERAGENTFORM}`, { state: { data: rowData } });
   
  }

  const handleViewDetails = (rowData) => {
    console.log("rowdata>", rowData);
    navigate(`${ROUTES_NAVIGATION.AGENTDETAILS}`, { state: { data: rowData } });
  }

  const clearFilter = () => {
    setFilterFormData({})
    setFilters({});
    fetchOnBoardList();
  };

  useEffect(() => {
    fetchOnBoardList();
  }, [filters]);

  const handleSearch = () => {
    // Update the filters state with the current form data
    setFilters({
      fromDate: filterFormData.startDate || null,
      toDate: filterFormData.endDate || null,
      city: filterFormData.city_id || null,
    });
  };




  const PhysicalStockTakingInputs = [
    {
      name: "startDate",
      label: "From Date",
      type: "date",
      maxDate: new Date(),  
      required: true,
      gridClass: "col-lg-2",
    },
    {
        name: "endDate",
        label: "To Date",
        type: "date",
        maxDate: new Date(),
        required: true,
        gridClass: "col-lg-2",
    },
    {
      name: "city_id",
      label: "City",
      placeholder:"Select City",
      type: "dropdown",
      options: city,
      required: true,
      gridClass: "col-lg-2",
    }
  ]

  useEffect(() => {
    if (searchTerm === "") {
      fetchOnBoardList();
    }
  }, [searchTerm]);
  return (
    <div>
    {loading ? (
      <Loader />
    ) : (
    <div>
      <div className='OnboardManagamentContainer row'>
        <div className='OnboardManagamentbuttonContainer col-xl-6 col-lg-12 mt-2 mb-2'>
          <h5>Onboard Management</h5>
       
        </div>
        <div className='totalvaluescontainer col-xl-6 col-lg-12 mt-2 mb-2'>
          <div  className='topleftdataContainer' style={{borderRight: "1px solid lightgrey"}}>
            <h5 className="listTopDataValueText" >{totalcust} </h5>
            <h6>Total Customers</h6>
          </div>
          <div className='topleftdataContainer '>
            <h5 className="listTopDataValueText" >{totalagent}</h5>
            <h6>Total Agents</h6>
          </div>
        
          <div>
            <button className='addcustomerbutton' onClick={handleAddButtonClick}>
              {renderAddButtonLabel()}
            </button>
          </div>
        </div>
      </div>

      {/* <ListFilters city={city} clearSearch={clearFilter} handleSearch={handleSearch} /> */}
      <ListLogisticsFilters
      formConfig={PhysicalStockTakingInputs} 
      formData={filterFormData}
      setFormData={setFilterFormData}
      validationErrors={validationErrors}
      setValidationErrors={setValidationErrors}
      handleSearch={handleSearch}
      handleClear={clearFilter}
      // onSubmit={handleFormSubmit} 
      />

      <div className='tableWrapper'>
        <div className='admin-list-container'>
          <div className='listsearchContainer'>
            <h5>{activeSection}</h5>
            <div>
              <SearchInput
                placeholder="Search Business Partner"
                onSearch={fetchOnBoardList}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
              />
              </div>
          </div>
        
        </div>

        <CustomTable 
        data={renderTableData()} 
        headers={renderTableHeaders()} 
        keyMapping={renderKeyMapping()} 
        handleViewButton={handleViewDetails}
        onEdit={handleEdit}
        itemsPerPage={10} 
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
        totalRecords={totalRecords} 
        />
      </div>
    </div>
    )}
    </div>
  );
};

export default Onboard;
